import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const deleteCrm = async (crm_id: Tables<"crm">["id"]) => await supabase.from("crm").delete().eq("id", crm_id).throwOnError();
